export default __webpack_public_path__ + "static/media/team81.71d4584c.JPG";